import { IGroupsEconomicState, IGroupEconomic } from "./groupsEconomicState";

export default {};
